import { AgentPortal } from '@wallet-manager/pfh-pmp-node-def-types';

import axios from '../axiosInstance';
import { GetAllRes } from 'src/views/DistributorAgentManagement/ReferralCode/types/GetAllRes';
import { GetDetailsRes } from 'src/views/DistributorAgentManagement/ReferralCode/types/GetDetailsRes';
import { GetDetailsParams } from 'src/views/DistributorAgentManagement/ReferralCode/types/GetDetailsParams';
import { DefaultListParams } from 'src/common/filterTable/types/DefaultListParams';

const getAll = async (params: any, config?: any) => {
  const { pageSize, page, ...rest } = params;

  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get<any, GetAllRes>(AgentPortal.EPtDaManagement.referralCode.getAll, input);
};

const getExport = async (params: any, config?: any) => {
  const { pageSize, page, ...rest } = params;

  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };

  return await axios.get<any, GetAllRes>(AgentPortal.EPtDaManagement.referralCode.export, input);
};

const getDetails = async (params: GetDetailsParams & DefaultListParams, config?: any) => {
  const { pageSize, page, ...rest } = params;

  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };

  const res = await axios.get<any, GetDetailsRes>(
    AgentPortal.EPtDaManagement.referralCode.details,
    input
  );

  return res;
};

export default {
  getAll,
  getExport,
  getDetails,
};
